<template>
<div>
    <section class="content">
      <!-- /.box -->
      <div class="box info-box">
        <div class="box-header with-border">
          Search By
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-3">
              <label for="Branch">Branch</label>
              <v-select v-model="branchFilter" name="branch_id" label="name" :options="branches" v-on:input="branchRecordWithLoadSettlementData" placeholder="Select Branch"></v-select>
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
            <div class="col-md-3" v-if="form.planType == 'group'"> 
              <label>Collection Center </label>
              <v-select v-model="colC"  name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Group" v-on:input="loadSettlementData" required> 
              </v-select>
            </div>
            <div class="col-md-3"> 
              <label>Customer</label>
              <v-select v-model="member"  name="Customer_name" label="name" :options="members" placeholder="Select Customer" v-on:input="loadSettlementDataWithCustomer" required> 
              </v-select>
            </div>
            <div class="col-md-3">
              <label for="date">Settlement Date</label>
              <input type="date" v-model="form.settlementDate" name="settlementDate" @change="loadSettlementDataWithSettlementDate" class="form-control" placeholder="EMI Date">
            </div>
            <div class="col-md-3">
              <label for="date">Settlement From</label>
              <input type="date" v-model="form.settlementStartDate" name="settlementStartDate" @change="loadSettlementData" class="form-control" placeholder="Settlement Date From">
            </div>
            <div class="col-md-3">
              <label for="date">Settlement To</label>
              <input type="date" v-model="form.settlementEndDate" name="settlementEndDate" @change="loadSettlementDataWithSettlementEndDate" class="form-control" placeholder="Settlement Date To">
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label
                  >Select Status <span class="red">*</span></label
                >
                <select
                  v-model="form.status"
                  name="status"
                  class="form-control"
                  @change="loadSettlementData"
                  :class="{
                    'is-invalid': form.errors.has('status'),
                  }"
                >
                  <option v-if="!form.status" selected value="">
                    Select Status
                  </option>
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                </select>
                <has-error :form="form" field="status"></has-error>
              </div>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('bank-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Settlement List</h3>
          
          <div class="box-tools">
            <!-- <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('bank-create')">
              <i class="fa fa-plus"></i> Add New
            </button> -->
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="loadSettlementData()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
                <a :href="`${this.$axios.defaults.baseURL}/sattlement/export/excel`" class="btn btn-box-tool">
                    <i class="fa fa-file-excel-o"></i> Download Excel
                </a>
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="loadSettlementData()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="loadSettlementData()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>Loan Id</th>
                <th class="hidden-xs">Mem Name</th>
                <th class="hidden-xs">(C/O) Alias</th>
                <th class="hidden-xs">Mem Mob</th>
                <th class="hidden-xs">Plan Amt</th>
                <th class="hidden-xs">Paid Amt</th>
                <th class="hidden-xs">Due Amt</th>
                <th class="hidden-xs">Settle Amt</th>
                <th class="hidden-xs">Settle Date</th>
                <th class="hidden-xs">Created By</th>
                <th class="hidden-xs">Pay Mode</th>
                <th class="hidden-xs">Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows.data" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td>{{ row.member_loan_plan.applicationNo }}</td>
                <td class="hidden-xs">{{ row.member.name }} - {{ row.member.code }}</td>
                <td class="hidden-xs">{{ row.member.alias }}</td>
                <td class="hidden-xs">{{ row.member.mobile }}</td>
                <td class="hidden-xs">{{ row.planAmount }}</td>
                <td class="hidden-xs">{{ row.totalAmountPaid }}</td>
                <td class="hidden-xs">{{ row.totalAmountDue }}</td>
                <td class="hidden-xs">{{ row.totalAmountPaidWithSettlement }}</td>
                <td class="hidden-xs">{{ row.sattlementDate | myDate }}</td>
                <td class="hidden-xs">{{ row.created_by.name }}</td>
                <td class="hidden-xs">{{ row.branch_ledger.ledger.name }}</td>
                <td class="hidden-xs">{{ row.status }}</td>
                <td>
                  <div class="btn-group">
                    <button v-if="row.status !== 'approved'"
                      @click="editModal(row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button
                      @click="viewModal(row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-delete')"
                      @click="deleteModal(row.id)"
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="loadSettlementData(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="loadSettlementData(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="loadSettlementData( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="loadSettlementData( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="loadSettlementData( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="loadSettlementData( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="loadSettlementData( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="loadSettlementData( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="loadSettlementData( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="loadSettlementData( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="loadSettlementData( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="loadSettlementData( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="loadSettlementData( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="loadSettlementData( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="loadSettlementData( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="loadSettlementData( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="loadSettlementData(null, 'next')"><a href="#">Next</a></li>
                <li @click="loadSettlementData(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.card -->
      <div class="modal fade" id="viewModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span></button>
              <h4 class="modal-title">Settlement Details</h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="card">
              
                    <!-- /.card-header -->
                    <div class="card-body" v-if="settlementDetails">
                      <ul class="todo-list ui-sortable" data-widget="todo-list">
                        <li v-if="settlementDetails.branch">
                          <span class="text">Branch Name : </span> {{settlementDetails.branch.name}}
                        </li>
                        <li v-if="settlementDetails.branch_ledger">
                          <span class="text">Payment Mode : </span> {{settlementDetails.branch_ledger.ledger.name}}
                        </li>
                        <li v-if="settlementDetails.member">
                          <span class="text">Member Name : </span> {{settlementDetails.member.name}}
                        </li>
                        <li v-if="settlementDetails.member">
                          <span class="text">Member code : </span> {{settlementDetails.member.code}}
                        </li>
                        <li v-if="settlementDetails.member">
                          <span class="text">Member Alias : </span> {{settlementDetails.member.alias}}
                        </li>
                        <li v-if="settlementDetails.member">
                          <span class="text">Member Contact Number : </span> {{settlementDetails.member.mobile}}
                        </li>
                        <li v-if="settlementDetails.member">
                          <span class="text">Member Email : </span> {{settlementDetails.member.email}}
                        </li>
                        <li v-if="settlementDetails.member_loan_plan">
                          <span class="text">Loan Application Number : </span> {{settlementDetails.member_loan_plan.applicationNo}}
                        </li>
                        <li v-if="settlementDetails.member_loan_plan">
                          <span class="text">Loan EMI Start Date : </span> {{settlementDetails.member_loan_plan.emiStartDate}}
                        </li>
                        <li v-if="settlementDetails.member_loan_plan">
                          <span class="text">Loan EMI End Date : </span> {{settlementDetails.member_loan_plan.emiEndDate}}
                        </li>
                        <li v-if="settlementDetails.member_loan_plan">
                          <span class="text">Loan Type : </span> {{settlementDetails.member_loan_plan.type}}
                        </li>
                        <li v-if="settlementDetails.collection_center">
                          <span class="text">Collection Center : </span> {{settlementDetails.collection_center.name}}
                        </li>
                        <li>
                          <span class="text">Total Plan amount : </span> {{settlementDetails.planAmount}}
                        </li>
                        <li>
                          <span class="text">Total Amount Paid : </span> {{settlementDetails.totalAmountPaid}}
                        </li>
                        
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card">
                    <ul class="todo-list ui-sortable" data-widget="todo-list">
                      <li>
                        <span class="text">Total Amount Due Without Interest : </span> {{settlementDetails.totalAmountDueWithoutInterest}}
                      </li>
                      <li>
                        <span class="text">Total Amount Due : </span> {{settlementDetails.totalAmountDue}}
                      </li>
                      <li>
                        <span class="text">Total Installment Paid : </span> {{settlementDetails.totalInstallmentPaid}}
                      </li>
                      <li>
                        <span class="text">Total Installment Due : </span> {{settlementDetails.totalInstallmentDue}}
                      </li>
                      <li>
                        <span class="text">Loan Pre Closing Charge Type : </span> {{settlementDetails.loanPreClosingChargeType}}
                      </li>
                      <li>
                        <span class="text">loanPreClosingCharge (%) : </span> {{settlementDetails.loanPreClosingCharge}}
                      </li>
                      <li>
                        <span class="text">Reason : </span> {{settlementDetails.reason}}
                      </li>
                      <li>
                        <span class="text">Settlement Date : </span> {{settlementDetails.sattlementDate}}
                      </li>
                      <li>
                        <span class="text">Remark : </span> {{settlementDetails.remark}}
                      </li>
                      <li v-if="settlementDetails.created_by">
                        <span class="text">Loan Settled By : </span> {{settlementDetails.created_by.name}}
                      </li>
                      <li>
                        <span class="text">Total Amount Paid With Settlement : </span> {{settlementDetails.totalAmountPaidWithSettlement}}
                      </li>
                      <li>
                        <span class="text">Settlement Status : </span> {{settlementDetails.status}}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.row -->
    </section>
         

</div>
</template>

<script>
import GetBranch from '../../mixins/BranchRecords'
import LoadSettlementData from '../../mixins/SettlementRecords'
import GetPaymentBranchLedgers from '../../mixins/PaymentBranchLedgers'
export default {
  name: 'Sattlement',
  mixins: [GetBranch, LoadSettlementData, GetPaymentBranchLedgers],
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      editMode: false,
      branches: [],
      dDtls: {},
      collectionCenters: [],
      branch: {},
      branchFilter: {},
      brLedgers: [],
      brLedger: {},
      members: [],
      payment_ledgers: [],
      colC: {},
      memberloanplans: [],
      emiRecords: [],
      emitotal: 0,
      mem: {},
      member: {},
      user_id: '',
      partialEMIRemainder: 0,
      userPlan: {},
      settlementDetails: {},
      form: new Form({
        id: '',
        branch_id: '',
        collection_center_id: '',
        member_id: '',
        settlementDate: '',
        settlementStartDate: '',
        settlementEndDate: '',
        branch_ledger_id: '',
        status: ''
      }),
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    viewModal (row) {
      this.settlementDetails = row
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
    },
    loadSettlementDataWithSettlementDate () {
      this.form.settlementStartDate = ''
      this.form.settlementEndDate = ''
      this.loadSettlementData()
    },
    loadSettlementDataWithSettlementEndDate () {
      this.form.settlementDate = ''
      this.loadSettlementData()
    },
    getMembers () {
      var c = JSON.parse(localStorage.user)
      this.userStatus = ''
      if (c.type !== 'admin') {
        if (c.role.name === 'Manager') {
          this.branch_record = `branch_id=${c.agent_profile.branch_id}`
        } else {
          this.branch_record = `&agent_id=${c.id}`
        }
      } else {
        this.branch_record = `branch_id=${this.form.branch_id}`
      }
      if (this.getSettingRecord === 'true') {
        this.userStatus = 'status=verified'
      }
      this.$axios
        .get('member?all=all&' + this.userStatus + '&' + this.branch_record, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.members = data.data
          _.forEach(this.members, function (item, key) {
            this.members[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
            if (this.form.member_id === item.user.id) {
              this.mem = item
            }
          }.bind(this))
        })
        .catch(
          function (error) {
            if (error.response.data.error) {
              var result = []
              var er = error.response.data.error
              for (var l in er) {
                if (er.hasOwnProperty(l)) {
                  result.push(l + ': ' + er[l])
                }
              }
              Toast.fire({ icon: 'error', title: result.join('\n') })
            }
            if (error.response.data.message) {
              let er = error.response.data.message
              Toast.fire({ icon: 'error', title: er })
            }
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    branchRecordWithLoadSettlementData () {
      this.form.branch_id = ''
      if (this.branchFilter) {
        this.form.branch_id = this.branchFilter.id
      }
      this.loadSettlementData()
    },
    loadSettlementDataWithCustomer () {
      if (this.member) {
        this.user_id = this.member.user_id
      }
      this.loadSettlementData()
    },
    getCollectionCenter () {
      this.$axios
        .get('collectioncenter?all=all&branch_id=' + this.branch.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.collectionCenters = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    settmentDateWise () {
      $.each(this.emiRecords, function (key, value) {
        // alert(new Date(value.emiDate).toISOString().slice(0, 10))
        if (new Date(value.emiDate).toISOString().slice(0, 10) === this.form.sattlementDate) {
          alert('hello')
        }
      })
    },
    getLoanMember () {
      // var multiplestatus = ['pending', 'processing']
      // this.colC.id = ''
      if (this.form.planType === 'group') {
        this.getCollectionCenter()
        // alert(this.colC.id)
        this.form.collection_center_id = this.colC.id
      }
      if (this.form.planType === 'individual') {
        this.collectionCenters = []
        this.colC = {}
        this.colC.id = ''
      }
      this.editMode = false
      this.memberloanplans = []
      this.mem = {}
      this.form.planName = ''
      this.form.memberName = ''
      this.form.applicationNumber = ''
      this.form.totalAmountPaidWithSettlement = 0
      this.form.planAmount = 0
      this.form.numberOfEMI = 0
      this.form.totalInstallmentPaid = 0
      this.form.totalAmountPaid = 0
      this.form.totalAmountDue = 0
      this.form.totalInstallmentDue = 0
      this.form.totalAmountDueWithoutInterest = 0
      this.form.loanPreClosingCharge = 0
      this.form.totalAmtDueWithPreClosingCharge = 0
      this.form.branch_id = this.branch.id
      this.getPaymentBranchLedgers()
      this.$axios
        .get('memberloanplan?all=all&branch_id=' + this.branch.id + '&collection_center_id=' + this.colC.id + '&searchTerm=' + this.form.planType + '&multiplestatus[]=processing&multiplestatus[]=pending', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          this.memberloanplans = data.data
          _.forEach(this.memberloanplans, function (item, key) {
            if (item.status === 'pending' || item.status === 'processing') {
              this.memberloanplans[key].name = item.member.name + ' (' + item.member.code + ')' + '( Application Number - ' + item.applicationNo + ')'
              if (this.form.member_id === item.member.id) {
                this.mem = item
              }
            }
          }.bind(this))
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    afterAmtLoanPreClosingCharge () {
      this.form.totalAmtDueWithPreClosingCharge = parseFloat(this.form.totalAmountDueWithoutInterest) + parseFloat(this.form.loanPreClosingCharge * this.form.totalAmountDueWithoutInterest / 100)
    },
    loanSettlement () {
      if (this.form.planType === 'individual') {
        this.$delete(this.form, 'collection_center_id')
      }
      this.$axios
        .post('sattlement', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          Toast.fire({
            icon: 'success',
            title: 'Dear User, Your Loan Settlemnt has been processed Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    }
  },
  created () {
    this.loadSettlementData()
    this.getMembers()
    this.getBranch()
    Fire.$on('AfterCreate', () => {
      this.loadSettlementData()
    })
  }
}
</script>



// WEBPACK FOOTER //
// SettlementReport.vue?cc153a70